import { useEffect, useState } from "react";
import axios from "axios";
import moment from "moment";
import { useSelector } from "react-redux";
import PosCashierNavbar from "../../Components/PosCashierNavbar";
import Loading from "../../Components/Loading";
import LoadingSpinner from "../../Components/Loader/UploadLoader";

const SHIFTENDPROCEDURE = () => {
  const BASEURL_GLOBAL = process.env.REACT_APP_BASEURL_GLOBAL;
  const BASEURL = process.env.REACT_APP_BASEURL;
  const authToken = window.sessionStorage.getItem("auth-token");
  const sessiontoken = window.sessionStorage.getItem("session-token");
  const userState = useSelector((state) => state.changeTheState.user);

  // --------------------------------------------------
  // Shift Header
  // --------------------------------------------------
  const [creditCardSales, setCreditCardSales] = useState(0);
  const [creditSales, setCreditSales] = useState(0);
  const [totalReceived, setTotalReceived] = useState(0);
  const [cashDrops, setCashDrops] = useState(0);
  const [expectedCash, setExpectedCash] = useState(0);
  const [physicalCash, setPhysicalCash] = useState("");
  const [accountableCashier, setAccountableCashier] = useState(
    userState?.emailId || "",
  );
  const [totalBills, setTotalBills] = useState(0);
  const [voidedBills, setVoidedBills] = useState(0);
  const [complimentaryBills, setComplimentaryBills] = useState(0);

  const [shiftNo, setShiftNo] = useState("");
  const [shiftDate, setShiftDate] = useState("");

  const [startDatetime, setStartDatetime] = useState("");
  const [endDatetime, setEndDatetime] = useState("");

  const [cashier, setCashier] = useState(userState?.emailId);

  // --------------------------------------------------
  // Shift Summary
  // --------------------------------------------------

  const [openingFloat, setOpeningFloat] = useState(0);
  const [cashSales, setCashSales] = useState(0);
  const [mpesaSales, setMpesaSales] = useState(0);
  const [otherSales, setOtherSales] = useState(0);
  const [totalSales, setTotalSales] = useState(0);
  const [closingFloat, setClosingFloat] = useState(0);
  const [loading, setLoading] = useState(false);


  
    const [pdfData, setPdfData] = useState(null);
  const [LoadingScreenBlock, setLoadingScreenBlock] = useState(false);
   const [company, setCompany] = useState({});
    const [PopUpReport, setPopUpReport] = useState(false);


  // ==================================================
  // COMMON HEADERS
  // ==================================================

  const getHeaders = () => ({
    headers: {
      "auth-token": authToken,
      "session-token": sessiontoken,
    },
  });

  // ==================================================
  // 1810
  // Get Next Available POS Shift Number and Date
  // ==================================================

  const getNextShiftDetails = async () => {
    try {
      setLoading(true);

      const response = await axios.get(
        `${BASEURL_GLOBAL}/globalViewHandler?viewname=1810`,
        getHeaders(),
      );

      const data = response?.data?.[0];

      if (!data) {
        console.warn("No shift data returned from View 1810");
        return;
      }

      /*
        Expected data from 1810 should contain something similar to:

        SHIFTNO
        SHIFTDATE
      */

      const nextShiftNo =
        data.SHIFTNO ?? data.SHIFTNUMBER ?? data.NEXTSHIFTNO ?? "";

      const nextShiftDate = data.SHIFTDATE ?? data.DATE ?? "";

      setShiftNo(nextShiftNo);

      if (nextShiftDate) {
        setShiftDate(moment(nextShiftDate).format("YYYY-MM-DD"));
      } else {
        setShiftDate(moment().format("YYYY-MM-DD"));
      }
    } catch (error) {
      console.error("Error fetching Shift 1810:", error);

      alert(
        error?.response?.data?.message ||
          "Unable to fetch next available Shift Number",
      );
    } finally {
      setLoading(false);
    }
  };

  // ==================================================
  // 1811
  // Shift Summary for Shift Date
  // ==================================================

  const getShiftSummary = async (date = shiftDate) => {
    if (!date) return;

    try {
      setLoading(true);

      const response = await axios.get(
        `${BASEURL_GLOBAL}/globalViewHandler?viewname=1811`,
        getHeaders(),
      );

      const selectedDate = String(date).split("T")[0];

      const data = response?.data?.find((item) => {
        const dbDate = String(item?.SHIFTDATE).split("T")[0];

        console.log("DB Date:", dbDate);
        console.log("Selected Date:", selectedDate);

        return dbDate === selectedDate;
      });

      if (!data) {
        clearSummary();
        return;
      }

      const opening = Number(data.OPENINGCASHSALES) || 0;
      const cash = Number(data.CASHSCOLLECTIONS) || 0;
      const mpesa = Number(data.MPESACOLLECTIONS) || 0;
      const creditCard = Number(data.CREDITCARDCOLLECTIONS) || 0;
      const credit = Number(data.CREDITSALES) || 0;
      const others = Number(data.OTHERSALES) || 0;
      const total = Number(data.TOTALSALES) || 0;
      const drops = Number(data.CASHDROPS) || 0;
      const expected = Number(data.EXPECTEDCASH) || 0;
      const closing = Number(data.CLOSINGFLOAT) || 0;

      const bills = Number(data.CASHSCOLLECTIONS) || 0;
      const voided = Number(data.VOIDEDBILLS) || 0;
      const complimentary = Number(data.COMPLIMENTARYBILLS) || 0;

      setOpeningFloat(opening);
      setCashSales(cash);
      setMpesaSales(mpesa);
      setCreditCardSales(creditCard);
      setCreditSales(credit);
      setOtherSales(others);
      setTotalReceived(total);
      setCashDrops(drops);
      setExpectedCash(expected);
      setClosingFloat(closing);

      // setTotalBills(bills);
      // setVoidedBills(voided);
      // setComplimentaryBills(complimentary);
    } catch (error) {
      console.error("Error fetching Shift Summary 1811:", error);

      alert(error?.response?.data?.message || "Unable to fetch Shift Summary");
    } finally {
      setLoading(false);
    }
  };

  // ==================================================
  // 1809
  // Shift Start / End Data
  // ==================================================

  const getShiftStartEndData = async () => {
    if (!shiftNo) return;

    try {
      const response = await axios.get(
        `${BASEURL_GLOBAL}/globalViewHandler?viewname=1809&SHIFTNO=${encodeURIComponent(
          shiftNo,
        )}`,
        getHeaders(),
      );

      const data = response?.data?.[0];

      if (!data) return;

      /*
        Expected fields from 1809 may contain:

        STARTDATETIME
        ENDDATETIME
        CASHIER
      */

      setStartDatetime(
        data.STARTDATETIME
          ? moment(data.STARTDATETIME).format("YYYY-MM-DDTHH:mm")
          : "",
      );

      setEndDatetime(moment().format("YYYY-MM-DDTHH:mm"));
    } catch (error) {
      console.error("Error fetching Shift Start/End 1809:", error);
    }
  };

  // ==================================================
  // INITIAL LOAD
  // ==================================================

  useEffect(() => {
    const initialize = async () => {
      await getNextShiftDetails();
    };

     axios
          .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=602`, {
            headers: {
              "auth-token": authToken,
              "session-token": sessiontoken,
            },
          })
          .then((res) => setCompany(res?.data[0]))
          .catch((err) => {
            setLoading(false);
            console.log("Error While fetching Driver List", err);
          });

    initialize();
  }, []);

  // ==================================================
  // WHEN SHIFT DATE CHANGES
  // ==================================================

  useEffect(() => {
    if (shiftDate) {
      getShiftSummary(shiftDate);
    }
  }, [shiftDate]);

  // ==================================================
  // WHEN SHIFT NUMBER CHANGES
  // ==================================================

  useEffect(() => {
    if (shiftNo) {
      getShiftStartEndData();
    }
  }, [shiftNo]);

  // ==================================================
  // CLEAR SUMMARY
  // ==================================================

  // Replace clearSummary with this.

  const clearSummary = () => {
    setOpeningFloat(0);
    setCashSales(0);
    setMpesaSales(0);
    setCreditCardSales(0);
    setCreditSales(0);
    setOtherSales(0);
    setTotalReceived(0);
    setCashDrops(0);
    setExpectedCash(0);
    setPhysicalCash("");
    setClosingFloat(0);
    // setTotalBills(0);
    // setVoidedBills(0);
    // setComplimentaryBills(0);
  };

  // ==================================================
  // END SHIFT - SP 1808
  // ==================================================

  const handleEndShift = async () => {
    if (!shiftNo) {
      alert("Shift Number is required");
      return;
    }

    if (!shiftDate) {
      alert("Shift Date is required");
      return;
    }

    if (!cashier) {
      alert("Please select Cashier");
      return;
    }

     try {
      const response = await axios.get(
        `${BASEURL_GLOBAL}/globalViewHandler?viewname=1809`,
        getHeaders(),
       );
       
       console.log(response.data)
       const filterData = response?.data?.filter((item) => moment(item?.SHIFTDATE).format("DD/MM/YYYY") === moment(shiftDate).format("DD/MM/YYYY"));

       console.log(filterData)

       if (filterData?.[0]?.SHIFTSTATUS === "ENDED") {
         alert("Day is already closed");
         return;
       }    
    } catch (error) {
      console.error("Error fetching closed shifts:", error);
    }

    const confirmEndShift = window.confirm(
      "Are you sure you want to End this Shift?",
    );

    if (!confirmEndShift) {
      return;
    }

    try {
      setLoading(true);

      const payload = {
        SHIFTNO: Number(shiftNo),
        
        CLOSINGFLOAT: Number(closingFloat || 0),

        DATE: moment(shiftDate)?.format("YYYY/MM/DD"),

        MPESACOLLECTIONS: Number(mpesaSales || 0),

        CASHCOLLECTIONS: Number(cashSales || 0),

        OTHERSCOLLECTION: Number(otherSales || 0),

        CASHSALES: Number(cashSales || 0),

        CREDITSALES: Number(creditSales || 0),

        CREDITCARDCOLLECTIONS: Number(creditCardSales || 0),

        VOIDEDBILLS: Number(voidedBills || 0),
        
        COMPLIMENTARYBILLS: Number(complimentaryBills || 0),
        
        PHYSICALCASHINHAND: Number(physicalCash || 0),

        VARIANCEAMOUNT: Number(variance || 0),

        CASHIERTOBECHARGEDAMOUNT: 0,

        // CASHIERTOBECHARGED: accountableCashier || "",

        NEWSHIFTEMPLOYEE: "",

        SHIFTENDDATETIME: moment().format("YYYY-MM-DD hh:mm:ss"),

        CLOSEDBY: userState?.emailId?.split("@")?.[0]?.toUpperCase() || "",
      };

      console.log("SP 1808 Payload:", payload);

      const response = await axios.post(
        `${BASEURL_GLOBAL}/globalSpHandler?spname=1808`,
        payload,
        getHeaders(),
      );

      if (response.status === 201) {
        alert("Shift Ended Successfully");

         const isPrint = window.confirm("Do you want to print this Receipt?");
        if (isPrint) {
          setPopUpReport(true);
          generateReport();
        } else {
        alert("You are now entering a new shift");
        await getNextShiftDetails();

        // Reset current shift
        setStartDatetime("");
        setEndDatetime("");
        setCashier("");  
        clearSummary();
      }
      } else {
        alert("Unable to End Shift");
      }
    } catch (error) {
      console.error("Error while ending Shift:", error);

      alert(
        error?.response?.data?.message ||
          "Something went wrong while ending the Shift",
      );
    } finally {
      setLoading(false);
    }
  };

  // ==================================================
  // FORMAT MONEY
  // ==================================================

  const variance = Number(expectedCash || 0) - Number(physicalCash || 0);

  const handlePhysicalCashChange = (e) => {
    const value = e.target.value;

    if (value === "" || /^\d*\.?\d{0,2}$/.test(value)) {
      setPhysicalCash(value);
    }
  };

  const formatAmount = (value) => {
    return Number(value || 0).toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

    // Crystal Reports
    function generateReport() {
      setPdfData(null);
  
      if (!shiftNo) {
        alert("Please Provide a Shift No");
        return;
      }
      setLoadingScreenBlock(true);
      axios
        .post(
          `${BASEURL}/generateReportsWith2Params`,
          {
            REPORTNAME: "CrPOSShiftReport.rpt",
            VALUE1: moment(shiftDate)?.format("YYYY-MM-DD"),
            VALUE2: Number(shiftNo),
            REPORTPATH: company?.REPORTPATH,
          },
          {
            headers: {
              "auth-token": authToken,
              "session-token": sessiontoken,
            },
            responseType: "blob",
          },
        )
        .then(async (res) => {
          console.log(res);
          const file = new Blob([res.data], { type: "application/pdf" });
          const fileURL = URL.createObjectURL(file);
          setPdfData(fileURL);
          setLoadingScreenBlock(false);
        })
        .catch((err) => {
          console.log("Error generating report:", err);
          setLoadingScreenBlock(false);
        });
  }
  
  
  const handleDownload = () => {
    const a = document.createElement("a");
    a.href = pdfData;
    a.download = "generated_report.pdf";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  if (loading) {
    return <Loading />;
  }

  // ==================================================
  // UI
  // ==================================================

  return (
    <div className="min-h-screen w-full bg-white text-[10px]">
      <PosCashierNavbar />

      {/* =====================================================
          PAGE TITLE
      ===================================================== */}

      <div className="w-full flex justify-center pt-2">
        <h1 className="text-[20px] font-bold uppercase text-red-600 underline">
          SHIFT PROCESSING
        </h1>
      </div>

      {/* =====================================================
          MAIN CONTENT
      ===================================================== */}

      <div className="mx-auto w-[95%] max-w-[1200px]">
        {/* =================================================
            SHIFT HEADER
        ================================================= */}

        <div className="overflow-x-auto">
          <table className="border-collapse border border-black">
            <thead>
              <tr className="bg-white">
                <th className="border border-black px-2 py-1 text-left font-normal">
                  Shift Number
                </th>

                <th className="border border-black px-2 py-1 text-left font-normal">
                  Shift Date
                </th>

                <th className="border border-black px-2 py-1 text-left font-normal">
                  Start Datetime
                </th>

                <th className="border border-black px-2 py-1 text-left font-normal">
                  End Datetime
                </th>

                <th className="border border-black px-2 py-1 text-left font-normal">
                  Cashier
                </th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td className="border border-black px-2 py-1">
                  <input
                    type="text"
                    value={shiftNo}
                    readOnly
                    className="h-7 w-[110px] border border-gray-400 px-1"
                  />
                </td>

                <td className="border border-black px-2 py-1">
                  <input
                    type="date"
                    value={shiftDate}
                    onChange={(e) => setShiftDate(e.target.value)}
                    className="h-7 w-[140px] border border-gray-400 px-1"
                  />
                </td>

                <td className="border border-black px-2 py-1">
                  <input
                    type="datetime-local"
                    value={startDatetime}
                    readOnly
                    className="h-7 w-[185px] border border-gray-400 px-1"
                  />
                </td>

                <td className="border border-black px-2 py-1">
                  <input
                    type="datetime-local"
                    value={endDatetime}
                    readOnly
                    className="h-7 w-[185px] border border-gray-400 px-1"
                  />
                </td>

                <td className="border border-black px-2 py-1">
                  <select
                    value={cashier}
                    onChange={(e) => setCashier(e.target.value)}
                    className="h-7 w-[250px] border border-gray-400 px-1"
                  >
                    <option value="">Select Cashier</option>

                    {userState?.emailId && (
                      <option value={userState.emailId}>
                        {userState.emailId}
                      </option>
                    )}
                  </select>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* =================================================
            SHIFT SUMMARY
        ================================================= */}

        <h2 className="mt-1 text-[10px] font-bold underline">
          Shift Summaries
        </h2>

        <table className="mt-1 border-collapse border border-black">
          <tbody>
            <tr>
              <td className="border border-black px-2 py-1">Opening Cash</td>

              <td className="border border-black px-2 py-1 text-right">
                {formatAmount(openingFloat)}
              </td>

              <td className="border border-black px-2 py-1"></td>
            </tr>

            <tr>
              <td className="border border-black px-2 py-1">Cash Sales</td>

              <td className="border border-black px-2 py-1 text-right">
                {formatAmount(cashSales)}
              </td>

              <td className="border border-black px-2 py-1">
                <button type="button" className="text-blue-700 underline">
                  View
                </button>
              </td>
            </tr>

            <tr>
              <td className="border border-black px-2 py-1">Mpesa Sales</td>

              <td className="border border-black px-2 py-1 text-right">
                {formatAmount(mpesaSales)}
              </td>

              <td className="border border-black px-2 py-1">
                <button type="button" className="text-blue-700 underline">
                  View
                </button>
              </td>
            </tr>

            <tr>
              <td className="border border-black px-2 py-1">
                Credit Card Sales
              </td>

              <td className="border border-black px-2 py-1 text-right">
                {formatAmount(creditCardSales)}
              </td>

              <td className="border border-black px-2 py-1">
                <button type="button" className="text-blue-700 underline">
                  View
                </button>
              </td>
            </tr>

            <tr>
              <td className="border border-black px-2 py-1">Credit Sales</td>

              <td className="border border-black px-2 py-1 text-right">
                {formatAmount(creditSales)}
              </td>

              <td className="border border-black px-2 py-1">
                <button type="button" className="text-blue-700 underline">
                  View
                </button>
              </td>
            </tr>

            <tr>
              <td className="border border-black px-2 py-1">Other Sales</td>

              <td className="border border-black px-2 py-1 text-right">
                {formatAmount(otherSales)}
              </td>

              <td className="border border-black px-2 py-1">
                <button type="button" className="text-blue-700 underline">
                  View
                </button>
              </td>
            </tr>

            <tr>
              <td className="border border-black px-2 py-1">Total Received</td>

              <td className="border border-black px-2 py-1 text-right">
                {formatAmount(totalReceived)}
              </td>

              <td className="border border-black px-2 py-1"></td>
            </tr>

            <tr>
              <td className="border border-black px-2 py-1">Cash Drops</td>

              <td className="border border-black px-2 py-1 text-right">
                {formatAmount(cashDrops)}
              </td>

              <td className="border border-black px-2 py-1">
                <button type="button" className="text-blue-700 underline">
                  View
                </button>
              </td>
            </tr>

            <tr>
              <td className="border border-black px-2 py-1">Expected Cash</td>

              <td className="border border-black px-2 py-1 text-right">
                {formatAmount(expectedCash)}
              </td>

              <td className="border border-black px-2 py-1"></td>
            </tr>

            <tr>
              <td className="border border-black px-2 py-1">Physical Cash</td>

              <td className="border border-black px-2 py-1">
                <input
                  type="text"
                  inputMode="decimal"
                  value={physicalCash}
                  onChange={handlePhysicalCashChange}
                  placeholder="0.00"
                  className="h-7 w-full border border-gray-400 px-1 text-right"
                />
              </td>

              <td className="border border-black px-2 py-1"></td>
            </tr>

            <tr>
              <td className="border border-black px-2 py-1">Variance</td>

              <td className="border border-black px-2 py-1 text-right">
                {formatAmount(variance)}
              </td>

              <td className="border border-black px-2 py-1"></td>
            </tr>

            <tr>
              <td className="border border-black px-2 py-1 align-top">
                Accountable Cashier
              </td>

              <td className="border border-black px-2 py-1">
                {Number(variance) !== 0 ? (
                  <select
                    value={accountableCashier}
                    onChange={(e) => setAccountableCashier(e.target.value)}
                    className="h-7 w-full border border-gray-400 bg-white px-1"
                  >
                    <option value="">Select Cashier</option>

                    {userState?.emailId && (
                      <option value={userState.emailId}>
                        {userState.emailId}
                      </option>
                    )}
                  </select>
                ) : (
                  ""
                )}
              </td>

              <td className="border border-black px-2 py-1"></td>
            </tr>

            <tr>
              <td className="border border-black px-2 py-1">Closing Float</td>

              <td className="border border-black px-2 py-1 text-right">
                {formatAmount(closingFloat)}
              </td>

              <td className="border border-black px-2 py-1"></td>
            </tr>

            {/* <tr>
              <td className="border border-black px-2 py-1">Total Bills</td>

              <td className="border border-black px-2 py-1 text-right">
                {formatAmount(totalBills)}
              </td>

              <td className="border border-black px-2 py-1"></td>
            </tr> */}

            {/* <tr>
              <td className="border border-black px-2 py-1">Voided Bills</td>

              <td className="border border-black px-2 py-1 text-right">
                {formatAmount(voidedBills)}
              </td>

              <td className="border border-black px-2 py-1"></td>
            </tr> */}

            {/* <tr>
              <td className="border border-black px-2 py-1">
                Complimentary Bills
              </td>

              <td className="border border-black px-2 py-1 text-right">
                {formatAmount(complimentaryBills)}
              </td>

              <td className="border border-black px-2 py-1"></td>
            </tr> */}
          </tbody>
        </table>

        {/* =================================================
            END SHIFT CONTROLS
        ================================================= */}

        <div className="mt-2 flex flex-wrap items-center gap-2">
          <button
            type="button"
            onClick={handleEndShift}
            className="h-8 border border-black bg-[#315b9b] px-6 text-white hover:bg-[#244779]"
          >
            End Shift
          </button>
          <button
            type="button"
            className="h-8 border border-black bg-[#315b9b] px-6 text-white hover:bg-[#244779]"
            onClick={() => {
                          setPopUpReport(true);
              generateReport()
            }}
          >
            Print Shift Report
          </button>
        </div>
      </div>


       {/* Report Generation */}
      
            {PopUpReport && (
              <div>
                <div
                  style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    zIndex: 99,
                  }}
                />
      
                <div
                  style={{
                    position: "fixed",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    backgroundColor: "white",
                    border: "1px solid black",
                    height: "80%",
                    width: "90%",
                    maxWidth: "90%",
                    maxHeight: "600px",
                    padding: "16px",
                    zIndex: 100,
                    overflowY: "auto",
                    borderRadius: "8px",
                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                  }}
                >
                  {LoadingScreenBlock && <LoadingSpinner />}
                  <button
              className="absolute top-2 right-2 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2 focus:outline-none focus:ring focus:border-blue-300"
              onClick={async() => {
                setPopUpReport(false)
                alert("You are now entering a new shift");
        await getNextShiftDetails();

        // Reset current shift
        setStartDatetime("");
        setEndDatetime("");
        setCashier("");  
        clearSummary();
              }}
                  >
                    Close
                  </button>
      
                  <section className="lg:flex lg:flex-col bg-white p-4 gap-2 shadow-lg rounded-md w-full min-h-[500px]">
                    <div>
                      <section className="lg:hidden block">
                        {pdfData && (
                          <button
                            className="bg-blue-500 text-white rounded-md px-2 py-1 block my-1"
                            onClick={handleDownload}
                          >
                            Download PDF
                          </button>
                        )}
                      </section>
      
                      <section className="hidden lg:block">
                        {pdfData ? (
                          <div className="w-full justify-center items-center min-h-screen p-4">
                            <section className="lg:flex lg:flex-col bg-white p-4 ga  shadow-lg rounded-md w-full min-h-[500px]">
                              <div>
                                {/* <div className="flex items-center gap-4"></div> */}
      
                                <section className="lg:hidden block">
                                  {pdfData && (
                                    <button
                                      className="bg-blue-900 text-white  h-7 text-lg rounded-md px-3 ml-2 mr-2 focus:outline-none focus:ring"
                                      onClick={handleDownload}
                                    >
                                      Download PDF
                                    </button>
                                  )}
                                </section>
      
                                <section className="hidden lg:block">
                                  {pdfData ? (
                                    <div className="mt-4">
                                      <h2 className="text-lg font-bold">
                                        Generated Report
                                      </h2>
                                      <iframe
                                        src={pdfData}
                                        title="Generated Report"
                                        width="100%"
                                        height="600px"
                                      ></iframe>
                                    </div>
                                  ) : (
                                    <p className="text-2xl font-bold my-4 text-center">
                                      No report available.
                                    </p>
                                  )}
                                </section>
                              </div>
                            </section>
                          </div>
                        ) : (
                          ""
                        )}
                      </section>
                    </div>
                  </section>
                </div>
              </div>
            )}
    </div>
  );
};

export default SHIFTENDPROCEDURE;
